import {
  ADD_CLASSIFIED_LISTING_REQUEST,
  EDIT_CLASSIFIED_LISTING_REQUEST,
  GET_CLASSIFIED_LISTING_REQUEST,
} from "../types";

const initialState = {
  classifiedListingRequestList: [],
  total: 0,
};

export default function classifiedListingRequestReducer(
  state = initialState,
  action,
) {
  const { type, payload } = action;

  switch (type) {
    case ADD_CLASSIFIED_LISTING_REQUEST:
      return {
        ...state,
        classifiedListingRequestList: [
          payload,
          ...state.classifiedListingRequestList,
        ],
      };

    case EDIT_CLASSIFIED_LISTING_REQUEST:
      const updatedclassifiedListingRequestList =
        state.classifiedListingRequestList.map((listing) => {
          if (listing.id === payload.id) {
            return { ...listing, ...payload?.updateDetails };
          }
          return listing;
        });
      return {
        ...state,
        classifiedListingRequestList: updatedclassifiedListingRequestList,
      };

    case GET_CLASSIFIED_LISTING_REQUEST:
      return {
        ...state,
        classifiedListingRequestList: payload?.data,
        total: payload?.total,
      };

    default:
      return state;
  }
}
